import { gql } from 'apollo-angular';

import {
  CONFIGURATION_VARIABLE_ASSIGNED_VALUES_FRAGMENT,
  CONFIGURATION_VARIABLE_CALCULATED_VALUES_FRAGMENT,
  CONFIGURATION_VARIABLE_NO_PRINTOUT_FRAGMENT,
  CONFIGURATION_VARIABLE_SHOW_FILTER_FRAGMENT,
  CONFIGURATION_VARIABLE_SHOW_IN_CONFIGURATION_FRAGMENT
} from 'graphql/fragments/configuration-variable';

export const PRODUCT_LINE_FILTERED_VARIABLES_FRAGMENT = gql`
  fragment ProductLineFilteredVariablesFragment on ProductLine {
    id
    configuration {
      sections(filter: { isVisible: true }) {
        id
        name
        sections (flatten: true) {
          variables: filteredVariables(paging: { page: 0, perPage: 250 }, filter: { isVisible: true }) {
            items {
              id
              name
              ...ConfigurationVariableAssignedValuesFragment
              ...ConfigurationVariableCalculatedValuesFragment
              ...ConfigurationVariableShowInConfigurationFragment
              ...ConfigurationVariableNoPrintoutFragment
              ...ConfigurationVariableShowFilterFragment
            }
          }
        }
      }
    }
  }
  ${CONFIGURATION_VARIABLE_ASSIGNED_VALUES_FRAGMENT}
  ${CONFIGURATION_VARIABLE_CALCULATED_VALUES_FRAGMENT}
  ${CONFIGURATION_VARIABLE_SHOW_IN_CONFIGURATION_FRAGMENT}
  ${CONFIGURATION_VARIABLE_NO_PRINTOUT_FRAGMENT}
  ${CONFIGURATION_VARIABLE_SHOW_FILTER_FRAGMENT}
`;
